export default __webpack_public_path__ + "static/media/GM.740c26da.svg";